import React, { Component } from 'react';
import range from 'lodash/range';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import { ACCOUNT_TYPE } from 'containers/ProfileDetailsPage/profileUtils';
import GenericDropdown from 'components/GenericDropdown';
import LoadingIndicator from 'components/LoadingIndicator';
import PaginationControls from 'components/PaginationControls';
import { MiamiDisclaimer } from 'components/WinLossStatement';
import { formatMoney } from 'utils/formatting';
import CloseIcon from 'resources/Icon-Close-Btn.svg';
import withWinLossData from '../WinLossStatement/withWinLossData';
import './WinLossStatementMobile.css';

class Statement extends Component {
  formatWinLossValue(number) {
    if (number < 0) {
      return `(${formatMoney(Math.abs(number * 100))})`;
    }

    return formatMoney(number * 100);
  }

  calculatePropertyTotal(property) {
    let total = 0;
    property.propertyValue.forEach(monthValue => {
      total += monthValue.value;
    });

    return this.formatWinLossValue(total);
  }

  scrollLeftProperty() {
    const { handleChangeProperty, selectedPropertyIndex, data } = this.props;
    const { winLossHistory } = data;

    if (winLossHistory.properties[selectedPropertyIndex - 1]) {
      handleChangeProperty(selectedPropertyIndex - 1);
    } else {
      const lastIndex = winLossHistory.properties.length - 1;
      handleChangeProperty(lastIndex);
    }
  }

  scrollRightProperty() {
    const { handleChangeProperty, selectedPropertyIndex, data } = this.props;
    const { winLossHistory } = data;

    if (winLossHistory.properties[selectedPropertyIndex + 1]) {
      handleChangeProperty(selectedPropertyIndex + 1);
    } else {
      handleChangeProperty(0);
    }
  }

  render() {
    const {
      accountNumber,
      year,
      handleSelectYear,
      yearsRange,
      data,
      selectedPropertyIndex,
      handleCloseModal
    } = this.props;
    const { winLossHistory } = data;
    const selectedProperty = winLossHistory.properties[selectedPropertyIndex];

    return (
      <div className="win-loss-statement-mobile">
        <h1 className="statement-title">WIN/LOSS STATEMENT</h1>
        <div className="statement-header">
          PCI Gaming dba
          <br />
          Wind Creek Hospitality
          <br />
          Player&apos;s Estimated Win/Loss for {year}
        </div>
        <div className="statement-info-container">
          <div className="account-number">
            <span className="field-header">Rewards Account:</span>
            <br />#{accountNumber}
          </div>
          <div className="year-select-container">
            <span className="field-header">Year:</span>
            <GenericDropdown
              className="year-select"
              dropdownId={`year-select-dropdown`}
              format="transparent"
              title={year}
              withHover={false}
              withSounds={false}
              withCaret
            >
              {yearsRange.map((yearOption, index) => (
                <div
                  key={index}
                  value={yearOption}
                  role="button"
                  onClick={e => handleSelectYear(e)}
                  className="year-dropdown-item"
                >
                  {yearOption}
                </div>
              ))}
            </GenericDropdown>
          </div>
        </div>
        <div className="statement-property-select-menu">
          <div className="selected-property-container">
            <h2 className="selected-property-name">{selectedProperty.name}</h2>
            <PaginationControls
              controls={winLossHistory.properties}
              activeIndex={selectedPropertyIndex}
              onPaginationChange={i => this.props.handleChangeProperty(i)}
              withSound={false}
              buttonsEnabled={true}
            />
          </div>
        </div>
        <div className="statement-result">
          <div className="statement-result-table">
            <div className="statement-result-header">
              <span>Month</span>
              <span>January</span>
              <span>February</span>
              <span>March</span>
              <span>April</span>
              <span>May</span>
              <span>June</span>
              <span>July</span>
              <span>August</span>
              <span>September</span>
              <span>October</span>
              <span>November</span>
              <span>December</span>
            </div>

            <div className="statement-result-property">
              <span>Amount</span>
              {selectedProperty.propertyValue.map((monthValue, j) => (
                <span key={j}>{this.formatWinLossValue(monthValue.value)}</span>
              ))}
            </div>
          </div>
          <hr />
          <div className="statement-result-total">
            <span className="total-label">Total</span>
            <span className="yearly-total-number">
              {this.calculatePropertyTotal(selectedProperty)}
            </span>
          </div>
        </div>
        <button type="button" onClick={handleCloseModal}>
          <img
            src={CloseIcon}
            alt="Close Dialog"
            className="close-modal-button"
          />
        </button>
      </div>
    );
  }
}

class StatementContainer extends Component {
  render() {
    const { loading, error } = this.props.data;
    if (loading) {
      return <LoadingIndicator />;
    }

    if (error) {
      return (
        <div className="win-loss-error alert alert-danger">
          Failed to retrieve Win Loss Statement. If this continues, please
          contact support.
        </div>
      );
    }

    return (
      <React.Fragment>
        <Statement {...this.props} ref={el => (this.componentRef = el)} />
      </React.Fragment>
    );
  }
}

const StatementContainerWithData = withWinLossData(StatementContainer);

class WinLossStatementMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: moment().year(),
      selectedPropertyIndex: 0
    };

    this.handleSelectYear = this.handleSelectYear.bind(this);
    this.handleChangeProperty = this.handleChangeProperty.bind(this);
  }

  handleSelectYear(event) {
    this.setState({
      year: parseInt(event.target.getAttribute('value'), 10) || moment().year()
    });
  }

  handleChangeProperty(index) {
    this.setState({
      selectedPropertyIndex: index
    });
  }

  render() {
    const {
      handleClose,
      show,
      accountType,
      accountNumber,
      joinYear,
      firstName,
      lastName
    } = this.props;
    let yearsRange = range(joinYear, moment().year() + 1).reverse();

    let content;
    if (accountType === ACCOUNT_TYPE.PLS_ACCOUNT) {
      content = <MiamiDisclaimer year={this.state.year} />;
    } else {
      content = (
        <StatementContainerWithData
          firstName={firstName}
          lastName={lastName}
          accountType={accountType}
          accountNumber={accountNumber}
          year={this.state.year}
          handleSelectYear={this.handleSelectYear}
          yearsRange={yearsRange}
          selectedPropertyIndex={this.state.selectedPropertyIndex}
          handleChangeProperty={this.handleChangeProperty}
          handleCloseModal={handleClose}
        />
      );
    }

    return (
      <Modal
        className="win-loss-statement-mobile-modal"
        onHide={handleClose}
        show={show}
      >
        <Modal.Body>{content}</Modal.Body>
      </Modal>
    );
  }
}

export default WinLossStatementMobile;
